@if (attachments$ | async; as attachments) { @if (attachments?.length) {
<div class="product-attachments">
  @for (attachment of attachments; track attachment) {
  <div class="product-attachment">
    <strong>{{ attachment.name }}</strong>
    <a class="download-link" [href]="attachment.url" rel="enclosure">{{
      'product.attachments.download.link' | translate
    }}</a>
    @if (attachment.description) {
    <p class="product-attachment-description">{{ attachment.description }}</p>
    }
  </div>
  }
</div>
} }
